/** Join optional Tailwind strings for layout JSON slots — no tailwind-merge deps in primitives. */
export function joinClasses(
  ...parts: (string | undefined | null | false)[]
): string {
  return parts.filter(Boolean).join(' ');
}
